import { render, staticRenderFns } from "./ResolveOrder.vue?vue&type=template&id=32acc280&scoped=true&"
import script from "./ResolveOrder.vue?vue&type=script&lang=js&"
export * from "./ResolveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32acc280",
  null
  
)

export default component.exports